// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"56":"Showcase","176":"Usage","466":"Demo"}[chunkId] + "." + {"56":"370ee584","176":"2de9eaf2","466":"27605fe9"}[chunkId] + ".js";
};